
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm6.521-17.918c0 4.082-3.107 8.791-8.79 8.791a8.608 8.608 0 01-4.723-1.397 6.21 6.21 0 004.575-1.275 3.085 3.085 0 01-2.884-2.146 3.08 3.08 0 001.397-.051 3.093 3.093 0 01-2.48-3.031v-.039c.417.23.891.372 1.397.385a3.076 3.076 0 01-1.377-2.57 3.1 3.1 0 01.416-1.55 8.765 8.765 0 006.37 3.23 3.09 3.09 0 015.26-2.82 6.255 6.255 0 001.96-.75 3.088 3.088 0 01-1.358 1.71 6.272 6.272 0 001.775-.486 6.331 6.331 0 01-1.544 1.602c.006.128.006.262.006.397z","fill":"currentColor"}})])
          )
        }
      }
    